<template>
  <div class="popup-button">
    <button
      class="button button--text button--icon"
      aria-label="Copy the current url to clipboard"
      @click="copyLinkHandler"
    >
      <i
        class="icon icon-link icon-color--gold icon--hoverable icon--xs"
        aria-hidden="true"
      ></i>
    </button>
    <div v-if="popupVisible" class="panel">
      <p>Copied</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  articleLink: {
    type: String,
    default: '',
  },
});

const popupVisible = ref(false);
const copyLinkHandler = () => {
  navigator.clipboard.writeText(
    props.articleLink ? props.articleLink : window.location.href,
  );
  showPopupHandler();
};
const showPopupHandler = () => {
  popupVisible.value = false;
  popupVisible.value = true;
  setTimeout(() => {
    popupVisible.value = false;
  }, 1000);
};
</script>
